import React, { SetStateAction, useState } from 'react';
import { ErrorToast, SuccessToast, WarningToast } from '../../../../../utils/toasters';
import { InfluencerService } from '../../../service';
import ProfileHeader from './ProfileHeader';
import ProfileAbout from './ProfileAbout';
import ProfileCategories from './ProfileCategories';
import ProfileSocial from './ProfileSocial';
import ProfileHighlighted from './ProfileHighlighted';
import { IProfileData } from '../../profile-view';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import { useTranslation } from 'react-i18next';
import TabPanel from '@mui/lab/TabPanel';
import { useParams } from 'react-router-dom';
import { IParams } from '../../../../../model/shared/IParams';
import ProfileKpiScreenshots from './ProfileKpiScreenshots';
import { useMediaQuery } from '@mui/material';
import { BootstrapBreakpoints } from '../../../../../enum/BootstrapBreakpoints';

interface IProfileFormProps {
    userState: IProfileData;
    setState: React.Dispatch<SetStateAction<IProfileData>>;
    setUpdatePlatforms: React.Dispatch<SetStateAction<boolean>>;
    setFilesScreenshots: React.Dispatch<SetStateAction<Blob[] | MediaSource[] | undefined>>;
    filesScreenshots: Blob[] | MediaSource[] | undefined;
    setFiles: React.Dispatch<SetStateAction<Blob[] | MediaSource[] | undefined>>;
    files: Blob[] | MediaSource[] | undefined;
    handleUploadFiles?: (files: Blob[] | MediaSource[]) => void;
}

const ProfileForm = ({
    userState,
    setState,
    setUpdatePlatforms,
    setFilesScreenshots,
    filesScreenshots,
    handleUploadFiles,
    files,
    setFiles,
}: IProfileFormProps) => {
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();
    const isMobile = useMediaQuery(`(max-width: ${BootstrapBreakpoints.LG}px)`);

    const [tab, selectTab] = useState('categories');
    // const [filesScreenshots, setFilesScreenshots] = useState<Blob[] | MediaSource[]>();

    const handleTab = (event: React.SyntheticEvent, newValue: string) => {
        selectTab(newValue);
    };

    const handleDeleteFile = async (postId: number) => {
        await InfluencerService.deleteHighlighted(postId, id ?? '')
            .then(response => {
                if (response) {
                    SuccessToast(t('general.successfullyDeletedImage'));
                    setUpdatePlatforms(prev => !prev);
                    // setState(response);
                }
            })
            .catch(error => ErrorToast(error));
    };

    const handleDeleteScreenshot = async (postId: number) => {
        await InfluencerService.deleteKpiScreenshot(postId, id ?? '')
            .then(response => {
                if (response) {
                    SuccessToast(t('general.successfullyDeletedImage'));
                    setState(response);
                }
            })
            .catch(error => ErrorToast(error));
    };

    return (
        <>
            <div className="d-none d-lg-block">
                <ProfileHeader />
            </div>
            <ProfileAbout state={userState?.user} setState={setState} />
            {isMobile && (
                <TabContext value={tab}>
                    <Box>
                        <TabList variant="fullWidth" onChange={handleTab} aria-label="lab API tabs example" centered>
                            <Tab
                                className="text-uppercase"
                                label={t('influencer.profile.categories')}
                                value="categories"
                            />
                            <Tab
                                className="text-uppercase"
                                label={t('influencer.profile.socialAccounts')}
                                value="social"
                            />
                        </TabList>
                        <Box className="mt-3">
                            <TabPanel className="p-0" value="categories">
                                <ProfileCategories state={userState?.user} setState={setState} />
                            </TabPanel>
                            <TabPanel className="p-0" value="social">
                                <ProfileSocial platforms={userState?.social} setUpdatePlatforms={setUpdatePlatforms} />
                            </TabPanel>
                        </Box>
                    </Box>
                </TabContext>
            )}
            {!isMobile && <ProfileCategories state={userState?.user} setState={setState} />}
            <div className="d-md-none">
                <ProfileHeader />
            </div>
            {!isMobile && <ProfileSocial platforms={userState?.social} setUpdatePlatforms={setUpdatePlatforms} />}
            <ProfileKpiScreenshots
                files={filesScreenshots}
                setFiles={setFilesScreenshots}
                user={userState?.user}
                isEditable
                handleUploadFiles={handleUploadFiles}
                handleDeleteFile={handleDeleteScreenshot}
            />
            <ProfileHighlighted
                user={userState?.user}
                isEditable
                handleDeleteFile={handleDeleteFile}
                files={files}
                setFiles={setFiles}
            />
        </>
    );
};

export default ProfileForm;
